import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const teamIncentiveProfitDetails = {
    id: 'teamIncentiveProfitDetails',
    // title: 'Dashboard',
    type: 'group',
    children: [
        {
            id: 'teamIncentiveProfitDetails',
            title: 'Team Incentive Profit Details',
            type: 'item',
            url: '/teamIncentiveProfit',
            icon: MonetizationOnIcon,
            breadcrumbs: false
        }
    ]
};

export default teamIncentiveProfitDetails;
